import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function MotoresPage() {
  useSeo({
    title: 'Motores Hidráulicos Industriais | Duraflow',
    description: 'Motores orbitais, de pistão axial, radial e engrenagem para aplicações industriais, agrícolas e móveis de alta performance.',
    keywords: 'motores hidráulicos, motores orbitais, motores de pistão, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/motores-hidraulicos',
    ogUrl: 'https://www.pilarmanutencao.com.br/motores-hidraulicos',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MOTORES-HIDRAULICOS/CARD/MOTORES-HIDRAULICOS.webp',
  });

  return (
    <DuraflowCategoryPage
      title="MOTORES HIDRÁULICOS"
      subtitle="Motores hidráulicos para aplicações que exigem torque, força e movimento rotativo confiável."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MOTORES-HIDRAULICOS/HERO/HERO-MOTORES-HIDRAULICOS.webp"
      heroImageAlt="Motores hidráulicos industriais de alto torque"
      description="Motores hidráulicos convertem energia hidráulica em movimento rotativo. São utilizados em sistemas que exigem força, torque e controle de rotação em máquinas industriais, agrícolas e móveis."
      applicationsTitle="Soluções atendidas"
      applications={[
        'Motores orbitais',
        'Motores de pistão',
        'Motores de engrenagem',
        'Motores para máquinas móveis',
        'Motores para acionamentos industriais',
        'Motores para sistemas de transporte',
        'Reposição sob consulta',
        'Identificação por código, placa ou aplicação',
      ]}
      applications2Title="Aplicações"
      applications2={[
        'Equipamentos agrícolas',
        'Máquinas móveis',
        'Esteiras transportadoras',
        'Guinchos',
        'Sistemas de giro',
        'Acionamentos industriais',
        'Equipamentos portuários',
        'Sistemas de tração hidráulica',
      ]}
      types={[
        {
          title: 'Motores de Engrenagem',
          description:
            'Motores de engrenagem externa para aplicações de alta velocidade e torque moderado, com excelente relação custo-benefício e durabilidade.',
        },
        {
          title: 'Motores Orbitais',
          description:
            'Motores orbitais de alta pressão com torque elevado em baixas rotações, ideais para aplicações de movimentação e posicionamento pesado.',
        },
        {
          title: 'Motores de Pistão Axial',
          description:
            'Motores de pistão axial com deslocamento fixo ou variável, para aplicações de alta performance com controle preciso de velocidade e torque.',
        },
        {
          title: 'Motores de Pistão Radial',
          description:
            'Motores de pistão radial com múltiplos êmbolos para torque extremo em baixas rotações, aplicados em guinchos e sistemas de içamento.',
        },
        {
          title: 'Motores de Palhetas',
          description:
            'Motores de palhetas com funcionamento suave e baixa pulsão, recomendados para aplicações que exigem regularidade no movimento rotativo.',
        },
        {
          title: 'Freios e Redutores',
          description:
            'Conjuntos de motores com freio hidráulico integrado e redutores de velocidade para aplicações com controle de posicionamento e segurança.',
        },
      ]}
      differentialsTitle="DIFERENCIAIS DURAFLOW"
      differentials={[
        'Atendimento técnico especializado',
        'Fornecimento sob consulta',
        'Apoio na identificação de componentes',
        'Análise da aplicação',
        'Alternativas compatíveis',
        'Cotação rápida via WhatsApp',
        'Suporte para manutenção industrial',
        'Soluções para reposição e novos projetos',
      ]}
      midCTA={{
        title: 'Precisa cotar um motor hidráulico?',
        text: 'Envie as informações de torque, rotação, vazão, pressão ou foto da plaqueta para nossa equipe técnica.',
        buttonText: 'Cotar motor hidráulico',
      }}
      ctaTitle="Precisa de uma solução hidráulica?"
      ctaText="Envie sua demanda para nossa equipe técnica. Podemos ajudar na identificação, cotação e fornecimento do componente mais adequado para sua aplicação."
      ctaButtonText="Chamar no WhatsApp"
    />
  );
}